'use strict';



class Assortment extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this.count = 4;
    this.countAll = 0;
    this.itemObjects = [];
  }
  connectedCallback() {
    this.conuter = this.querySelector('.ass-counter');
    this.buttonNext = this.querySelector('.ass-next');
    this.buttonPrev = this.querySelector('.ass-prev');

    this.ids = [];

    this.items = this.querySelectorAll('.assortment-item');

    Array.from(this.items).forEach((item, index) => {
      const button = item.querySelector('.assortment-delete');

      const id = button.dataset.id;
      if (id) this.ids.push(id);

      const obj = {
        item,
        button,
        index
      };
      this.itemObjects.push(obj);

      button.addEventListener('click', () => {
        if (this.itemObjects.length < 2) return;

        const index = this.ids.indexOf(id);
        this.ids.splice(index, 1);

        const elements = this.querySelectorAll(`.assortment-scroll-inner .assortment-cell:nth-child(${obj.index + 1})`);

        Array.from(elements).forEach(el => el.remove());

        for (let i = obj.index + 1; i < this.itemObjects.length; i++) {
          this.itemObjects[i].index = this.itemObjects[i].index - 1;
        }

        this.itemObjects.splice(obj.index, 1);

        this.countAll = this.itemObjects.length;
        this.count = Math.min(this.count, this.countAll);

        this._updateCounter();
      });
    });

    this.targetLinks = document.querySelectorAll('.assortmentTargetLink');

    Array.from(this.targetLinks).forEach(link => {
      const target = link.dataset.target;

      link.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.ids.length) return;
        window.open(target + this.ids.join(','), '_blank');
      });
    })

    this.countAll = this.items.length;
    this.count = Math.min(this.count, this.countAll);

    if (this.countAll > this.count) {
      this.buttonNext.addEventListener('click', () => {
        this.count++;
        if (this.count > this.countAll) this.count = Math.min(4, this.countAll);
        this._updateCounter();
      });

      this.buttonPrev.addEventListener('click', () => {
        this.count--;
        if (this.count < Math.min(4, this.countAll)) this.count = this.countAll;
        this._updateCounter();
      });
    } else {
      this.classList.add('nothing');
    }


    this._updateCounter();
  }
  disconnectedCallback() {
  }
  _updateCounter() {
    this.conuter.innerHTML = `${this.count} / ${this.countAll}`;

    const newCount = Math.min(4 - this.count, 0);

    this.style.setProperty('--count', newCount.toString());
  }
}

window.customElements.define('assortment-view', Assortment);